export interface MaterialNoteDraft {
  body: string;
  base_version: number;
  expires_at: number;
}
const PREFIX = 'airbotix.study.material-note-draft.';
const TTL = 24 * 60 * 60 * 1000;
const key = (owner: string, note: string) => `${PREFIX}${owner}:${note}`;
export function readMaterialNoteDraft(owner: string, note: string): MaterialNoteDraft | null {
  try {
    const value: unknown = JSON.parse(sessionStorage.getItem(key(owner, note)) ?? 'null');
    if (
      !value ||
      typeof value !== 'object' ||
      !('body' in value) ||
      typeof value.body !== 'string' ||
      value.body.length > 12000 ||
      !('base_version' in value) ||
      typeof value.base_version !== 'number' ||
      !('expires_at' in value) ||
      typeof value.expires_at !== 'number' ||
      value.expires_at <= Date.now()
    ) {
      sessionStorage.removeItem(key(owner, note));
      return null;
    }
    return value as MaterialNoteDraft;
  } catch {
    return null;
  }
}
export function keepMaterialNoteDraft(owner: string, note: string, body: string, version: number) {
  try {
    sessionStorage.setItem(
      key(owner, note),
      JSON.stringify({
        body,
        base_version: version,
        expires_at: Date.now() + TTL,
      }),
    );
  } catch {
    /* The unsaved-state guard remains active if private storage is blocked. */
  }
}
export function clearMaterialNoteDraft(owner: string, note: string) {
  try {
    sessionStorage.removeItem(key(owner, note));
  } catch {
    /* Optional local draft. */
  }
}
